export default __webpack_public_path__ + "../ckeditor/plugins/tableselection/styles/tableselection.css";